export default __webpack_public_path__ + "videos/ecco_spinner.mp4";